/**
 * Component to assign Validation colours to the text with icons
 *
 * @module views/components/ContextualTag
 * @memberof -Common
 */
import './ContextualTag.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Icon from '@ulta/core/components/Icon/Icon';
import Text from '@ulta/core/components/Text/Text';


/**
 * Represents a ContextualTag component
 *
 * @method
 * @param { ContextualTagProps} props - React properties passed from composition
 * @returns ContextualTag
 */
export const ContextualTag = function( props ){

  const {
    color,
    label,
    icon
  } = props;

  if( !props.color || !props.label ){
    return null;
  }

  return (
    <div className={
      classNames( 'ContextualTag', {
        [`ContextualTag--${color}`]: color
      } )
    }
    >
      { icon && (
        <Icon className='ContextualTag__icon'
          size='s'
          name={ icon }
          aria-hidden={ true }
        />
      ) }
      <div className='ContextualTag__label'>
        <Text
          textStyle='body-3'
          htmlTag='p'
        >
          { label }
        </Text>
      </div>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef ContextualTagProps
 * @type {object}
 * @property {string} color - Sets the background color for the ContextualTag
 * @property {string} label - Sets the text inside the ContextualTag
 * @property {string} icon - Sets the type of icon within the Contextual Tag
 */
export const propTypes =  {
  color: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string
};

ContextualTag.propTypes = propTypes;

export default ContextualTag;